import { Component, OnInit, AfterViewInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

import { AppContext, SeoService } from './../../shared';
import { BlogPage } from  './../blog-page';

@Component({
  selector: 'linescape-more-data-anniversary',
  template: require('./linescape-more-data-anniversary.component.html'),
  styles: [require('./../blog.component.scss'), require('./linescape-more-data-anniversary.component.scss')]
})
export class LinescapeMoreDataAnniversaryComponent extends BlogPage {
  title = 'Linescape celebrates 3rd Anniversary with "More Data" - Linescape';
  description = "Sailing Schedules Website Expands Depth and Breadth of Data Offering.";

  constructor(route: ActivatedRoute, app: AppContext, seo: SeoService) {
    super(route, app, seo);
  }
}


// WEBPACK FOOTER //
// ./node_modules/angular-router-loader/src!./node_modules/angular2-template-loader!./node_modules/@angularclass/hmr-loader!./node_modules/tslint-loader!./src/app/press/linescape-more-data-anniversary/linescape-more-data-anniversary.component.ts